import { render, staticRenderFns } from "./activist.vue?vue&type=template&id=26b6ff2f&scoped=true"
import script from "./activist.vue?vue&type=script&lang=js"
export * from "./activist.vue?vue&type=script&lang=js"
import style0 from "./activist.vue?vue&type=style&index=0&id=26b6ff2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b6ff2f",
  null
  
)

export default component.exports